/**
 * 根据选中的变体同步显示/隐藏产品图片
 * @param {Object} variant - 当前选中的变体对象
 */
function syncVariantImages(variant) {
  if (!variant) return;

  // 1. 获取关键标识
  const featuredMediaId = variant.featured_media?.id;
  const option1Value = variant.option1 ? variant.option1.toLowerCase() : '';
  
  // 2. 获取所有需要控制的媒体元素 (根据你的主题HTML结构调整选择器)
  // 通常 Shopify 2.0 主题的缩略图按钮或 li 元素上有 data-media-id
  const mediaElements = document.querySelectorAll('.product-gallery__thumbnail, .product__media-item');

  mediaElements.forEach(el => {
    // 获取元素的媒体ID (可能在 dataset 中，也可能在子元素 img 的 alt 中)
    const mediaId = el.dataset.mediaId || el.querySelector('img')?.dataset.mediaId;
    const imgAlt = el.querySelector('img')?.alt?.toLowerCase() || '';
    
    let shouldShow = false;

    // --- 匹配逻辑开始 ---
    
    // 规则 A: 精确匹配主图 ID (最推荐，准确无误)
    if (featuredMediaId && String(mediaId) === String(featuredMediaId)) {
      shouldShow = true;
    }
    // 规则 B: 匹配 Alt 文本中的颜色/选项名 (适用于展示该颜色的所有角度图)
    // 例如：变体是 "Red"，图片 Alt 是 "Red Front View"
    else if (option1Value && imgAlt.includes(option1Value)) {
      shouldShow = true;
    }
    // 规则 C: 通用图片 (Alt 包含 "common", "all", "detail" 等关键词)
    else if (imgAlt.includes('common') || imgAlt.includes('all')) {
      shouldShow = true;
    }
    // 规则 D: 视频或 3D 模型通常始终显示 (可选)
    else if (el.dataset.mediaType !== 'image') {
      shouldShow = true;
    }
    
    // --- 匹配逻辑结束 ---

    const mediaElement = document.querySelector(`.product-gallery__media[data-media-id="${mediaId}"]`);

    // 3. 应用显示/隐藏状态
    if (shouldShow) {
      el.removeAttribute('hidden');
      el.classList.remove('hidden-thumbnail'); // 确保你的CSS中有 .hidden-thumbnail { display: none; }

      if (mediaElement) {
        mediaElement.removeAttribute('hidden');
      }

    } else {
      el.setAttribute('hidden', '');
      el.classList.add('hidden-thumbnail');

      if (mediaElement) {
        mediaElement.setAttribute('hidden', '');
      }
    }
  });
}



